import React from 'react';
import { CircleHelp } from 'lucide-react';
import clsx from 'clsx';

import CommonTooltip from '../../../components/common-tooltip/CommonTooltip';

import scss from './SectionTitle.module.scss';

function SectionTitle({ title, help, icon: Icon, className }) {
  return (
    <h4 className={clsx(scss.title, className)}>
      {Icon ? <Icon width={16} height={16} /> : null}
      {title}
      {help ? (
        <CommonTooltip title={help} placement='right'>
          <button type='button' className={scss.help} aria-label={help}>
            <CircleHelp size={13} />
          </button>
        </CommonTooltip>
      ) : null}
    </h4>
  );
}

export default SectionTitle;
